import { render, staticRenderFns } from "./SuppliersBookingSettingsCustomField.vue?vue&type=template&id=60e48a6e&"
import script from "./SuppliersBookingSettingsCustomField.vue?vue&type=script&lang=js&"
export * from "./SuppliersBookingSettingsCustomField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports